<script setup lang="ts">
const route = useRoute()

const steps = [
  // {
  //   step: 0,
  //   name: 'Winkelwagen',
  //   url: '/cart/'
  // },
  {
    step: 1,
    name: 'Details',
    url: '/checkout/',
  },
  {
    step: 2,
    name: 'Shipping',
    url: '/checkout/shipment/',
  },
  {
    step: 3,
    name: 'Payment',
    url: '/checkout/payment/',
  },
]

const currentStep = computed(() => {
  switch (true) {
    case route.path.includes('/payment/'):
      return 3
    case route.path.includes('/shipment/'):
      return 2
    case route.path.includes('/checkout/'):
      return 1
  }

  return 1
})
</script>

<template>
  <ol class="steps">
    <li
      v-for="step in steps"
      :key="step.step"
      class="steps__step"
      :class="{ 'steps__step--todo': currentStep < step.step, 'steps__step--current': currentStep === step.step, 'steps__step--done': currentStep > step.step }"
    >
      <AppLink
        class="steps__link"
        :to="step.url"
      >
        {{ $t(step.name) }}
      </AppLink>
    </li>
  </ol>
</template>

<style>
@import url("~layers/components/Checkout/Steps.css");
</style>
